export default __webpack_public_path__ + "static/Food5-bc172f352d8ab505b0d5bc91fbb75ef3.jpg";